import { ApiUtility } from "../Utilities/ApiUtility.axios";

class TicketAlertTemplatesService {
  route = "/TicketAlertTemplates";

  get = (id: string) => ApiUtility.get(`${this.route}/${id}`);

  getAlertEvents = () => ApiUtility.get(`${this.route}/AlertEvents`);

  getList = (
    start: number,
    length: number,
    search?: string,
    sortCol?: string,
    sortDir?: string,
    isActive?: string
  ) =>
    ApiUtility.get(`${this.route}`, {
      start,
      length,
      search,
      sortCol,
      sortDir,
      isActive,
    });

  post = (id: string, params: any) =>
    ApiUtility.postForm(`${this.route}${id ? "/" + id : ""}`, params);

  downloadAttachment = (id: string, fileId: string, download: boolean) =>
    ApiUtility.downloadFile(
      `${this.route}/${id}/fileId/${fileId}/Attachments?download=${download}`
    );

  deleteAttachment = (id: string, fileId: string) =>
    ApiUtility.post(`${this.route}/${id}/fileId/${fileId}/deleteAttachments`, {});

  toggleCannedMessage = (id: string, field: string, isTrue: boolean) =>
    ApiUtility.post(`${this.route}/${id}/Toggle?field=${field}&isTrue=${isTrue}`, {});
}

export default new TicketAlertTemplatesService();
